import React from "react";
import Items from "./Items"; // Import the Items component
import { Link } from "react-router-dom"; // Import Link for navigation
import "./HomePage.css";
import vid from "../Assets/vid.mp4"; // Import the video

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Video Section */}
      <div className="video-container">
        <video autoPlay loop muted className="background-video">
          <source src={vid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <h1 style={{ fontSize: "4rem" }}>Savor the Sweetness</h1>

      {/* Render multiple Items components */}
      <div className="items-container">
        <Items reverse={false} /> {/* Image on the right */}
        <Items reverse={true} /> {/* Image on the left */}
        <Items reverse={false} />
      </div>

      {/* Explore All Button */}
      <div className="explore-button-container">
      <Link to='/catalog'>  <button class="animated-button">
  <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
    ></path>
  </svg>
   <span class="text">Explore More</span>
  <span class="circle"></span>
  <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
    ></path>
  </svg>
</button></Link>      </div>
    </div>
  );
};

export default HomePage;
